import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { TEAM_ASSIGN_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  userId: string;
  data: FieldValues;
}
const mutateAddUpdateTeam = async ({
  projectId,
  userId,
  data,
}: mutateProps) => {
  return await axiosAuth.put(
    `${TEAM_ASSIGN_API}/${projectId}/users/${userId}/role`,
    data
  );
};

const useAddUpdateTeamMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddUpdateTeam,
    ...queryParams,
  });

export default useAddUpdateTeamMutation;
